import { stories } from "@/mocks/story";
import { casts } from "@/mocks/cast";
import { clips } from "@/mocks/clip";

export interface Story {
  id: string;
  title: string;
  subtitle: string;
  season: string;
  episode: number;
  tags: string[];
  cover: string;
  summary: string;
  content: string[];
  publishedAt: string;
  castIds: string[];
  clipIds: string[];
}

export interface Cast {
  id: string;
  name: string;
  initial: string;
  role: string;
  roleType: string;
  avatar: string;
  roleIntro: string;
  bio: string[];
  storyIds: string[];
}

export interface Clip {
  id: string;
  title: string;
  type: string;
  duration: number;
  thumbnail: string;
  description: string;
  storyId: string;
  views: number;
}

export const storyList: Story[] = stories;
export const castList: Cast[] = casts;
export const clipList: Clip[] = clips;

export const getStoryById = (id?: string): Story | undefined =>
  storyList.find((item) => item.id === id);

export const getCastById = (id?: string): Cast | undefined =>
  castList.find((item) => item.id === id);

export const getClipById = (id?: string): Clip | undefined =>
  clipList.find((item) => item.id === id);

export const getCastsByIds = (ids: string[]): Cast[] =>
  ids.map((id) => getCastById(id)).filter((item): item is Cast => Boolean(item));

export const getClipsByIds = (ids: string[]): Clip[] =>
  ids.map((id) => getClipById(id)).filter((item): item is Clip => Boolean(item));

export const getStoriesByIds = (ids: string[]): Story[] =>
  ids.map((id) => getStoryById(id)).filter((item): item is Story => Boolean(item));

export const formatDuration = (seconds: number): string => {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${String(s).padStart(2, "0")}`;
};

export const formatViews = (views: number): string => {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return String(views);
};

export interface SearchResult {
  stories: Story[];
  casts: Cast[];
  clips: Clip[];
}

export const searchAll = (keyword: string): SearchResult => {
  const q = keyword.trim().toLowerCase();
  if (!q) {
    return { stories: [], casts: [], clips: [] };
  }
  return {
    stories: storyList.filter(
      (s) =>
        s.title.toLowerCase().includes(q) ||
        s.summary.toLowerCase().includes(q) ||
        s.tags.join("").toLowerCase().includes(q),
    ),
    casts: castList.filter(
      (c) =>
        c.name.toLowerCase().includes(q) ||
        c.role.toLowerCase().includes(q) ||
        c.roleIntro.toLowerCase().includes(q),
    ),
    clips: clipList.filter(
      (k) => k.title.toLowerCase().includes(q) || k.description.toLowerCase().includes(q),
    ),
  };
};

export const storySeasons = ["全部", "第一季", "第二季", "特别篇"];
export const castInitials = ["全部", "C", "G", "H", "J", "L", "Q", "S", "Z"];
export const castRoleTypes = ["全部", "主角", "配角"];
export const clipTypes = ["全部", "剧情回顾", "精彩对白", "花絮"];